<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
      shaped
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-col cols="12" class="ml-1">
        <h2 class="titulo">Dashboard</h2>
        <v-divider class="mt-2"></v-divider>
      </v-col>
    </v-row>

    <v-container fluid v-show="this.primeiraRodada" class="text-center">
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-circular>
    </v-container>

    <v-container fluid v-show="!this.primeiraRodada">
      <v-row class="d-flex ml-2 pa-0 mb-2">
        <v-col cols="12">
          <v-row class="mr-0 mt-3">
            <div class="altura-maxima-div-filtros">
              <v-row>
                <p
                  v-show="
                    usuarioLogado
                      ? usuarioLogado.perfil.id != tiposPerfilUsuario.ANALISTA
                      : false
                  "
                  class="texto-label"
                >
                  Escolha o tipo de visualização:
                </p>
              </v-row>
              <v-row>
                <v-radio-group
                  mandatory
                  v-show="
                    usuarioLogado
                      ? usuarioLogado.perfil.id != tiposPerfilUsuario.ANALISTA
                      : false
                  "
                  v-model="tipoVisao"
                  @change="exibirOpcoesVisao"
                  class="ma-0 mt-1"
                  row
                >
                  <v-radio value="Analista">
                    <template v-slot:label>
                      <div>Analista</div>
                    </template>
                  </v-radio>
                  <v-radio value="Grupo">
                    <template v-slot:label>
                      <div>Grupo</div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <v-autocomplete
                  v-show="
                    usuarioLogado
                      ? usuarioLogado.perfil.id != tiposPerfilUsuario.ANALISTA
                      : false
                  "
                  :items="analistas"
                  outlined
                  dense
                  style="max-width: 200px"
                  label="Analista"
                  v-model="analistaSelecionado"
                  class="mr-2"
                  v-if="isFiltroAnalista"
                ></v-autocomplete>

                <v-autocomplete
                  v-show="
                    usuarioLogado
                      ? usuarioLogado.perfil.id != tiposPerfilUsuario.ANALISTA
                      : false
                  "
                  :items="grupos"
                  outlined
                  dense
                  label="Grupo"
                  style="max-width: 200px"
                  v-model="grupoSelecionado"
                  item-text="descricao"
                  return-object
                  class="mr-2"
                  v-if="isFiltroGrupo"
                >
                  <template v-slot:item="{ item }">
                    {{ item.descricao }}
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  :items="tipoFiltroItems"
                  outlined
                  dense
                  label="Período"
                  v-model="periodoFiltro"
                  :style="tamanhoCampoFiltro"
                  @change="exibirCamposData"
                  class="mr-2"
                ></v-autocomplete>

                <Datepicker
                  :mensagemDeErro="erroDataInicial"
                  :entrada="periodoInicial"
                  v-model="periodoInicial"
                  class="sem-border-radius-input mr-2"
                  v-if="filtroPersonalizado"
                  label="Data inicial"
                  style="width: 170px; text-align: center;"
                  dica="* Período máximo de 90 dias"
                  @blur="validaDatas()"
                />
                
                <Datepicker
                  :mensagemDeErro="erroDataFinal"
                  :entrada="periodoFinal"
                  v-model="periodoFinal"
                  class="sem-border-radius-input mr-2"
                  v-if="filtroPersonalizado"
                  label="Data final"
                  style="width: 170px; text-align: center;"
                  dica="* Período máximo de 90 dias"
                  @blur="validaDatas()"
                />

                <v-btn
                  color="primary"
                  class="btn-primary ma-0"
                  style="height: 39px"
                  @click="filtrarInformacoesDashboard"
                  :loading="loading"
                  >Filtrar</v-btn
                >
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      outlined
                      class="ma-0 ml-2 px-2"
                      style="height: 39px"
                      v-bind="attrs"
                      v-on="on"
                      @click="gerarPDFdeRelatorio"
                      :disabled="desabilitarBotaoPdf"
                    >
                      <span>Exportar</span>
                      <v-icon color="primary" class="ml-1"
                        >mdi-file-pdf-box</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Gerar PDF</span>
                </v-tooltip>
              </v-row>
            </div>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-3 fonte-legeda">
        <v-col class="col-7 col-md-9">
          Dados exibidos correspondentes a
          {{ nomeDoLoginOuGrupoFiltrado }} no período de {{ formatarDataInicial }} a
          {{ formatarDataFinal }}
        </v-col>
        <v-col class="col text-end">
          Legenda
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="lightgray"
                fab
                elevation="3"
                class="btn-info ml-3"
                v-bind="attrs"
                v-on="on"
                @click="abrirModalLegendas"
              >
                <v-icon color="primary" small>mdi-information-variant</v-icon>
              </v-btn>
            </template>
            <span>Legendas</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row v-show="!apresentarDashboard">
        <v-col cols="12" class="px-2">
          <div class="sem-informacoes-periodo">
            <p>Não há informações a serem apresentadas no período.</p>
          </div>
        </v-col>
      </v-row>

      <v-row v-show="apresentarDashboard">
        <v-col cols="12" sm="6" class="pa-2">
          <v-card class="mx-auto">
            <h3 class="titulo-grafico">Atendimentos abertos</h3>
            <div v-show="!loading && !erroConexao">
              <v-card-text
                class="tamanho-grafico d-flex justify-center align-center"
                id="grafico-chamados-abertos"
              >
              </v-card-text>
            </div>
            <v-card-text
              v-if="loading || erroConexao"
              class="tamanho-grafico d-flex justify-center align-center"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div class="mensagem-erro" v-if="erroConexao">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-3"
                      color="red"
                      large
                      v-bind="attrs"
                      v-on="on"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </template>
                  <span>Erro de conexão</span>
                </v-tooltip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" class="pa-2">
          <v-card class="mx-auto" min-height="200">
            <h3 class="titulo-grafico">Atendimentos resolvidos</h3>
            <div v-show="!loading && !erroConexao">
              <v-card-text
                class="tamanho-grafico d-flex justify-center align-center"
                id="grafico-chamados-resolvidos"
              >
              </v-card-text>
            </div>
            <v-card-text
              v-if="loading || erroConexao"
              class="tamanho-grafico d-flex justify-center align-center"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div class="mensagem-erro" v-if="erroConexao">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-3"
                      color="red"
                      large
                      v-bind="attrs"
                      v-on="on"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <!-- <span class="ml-3">Erro de conexão</span> -->
                  </template>
                  <span>Erro de conexão</span>
                </v-tooltip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-show="apresentarDashboard">
        <v-col cols="12" lg="6" class="pa-2">
          <v-card min-height="290" class="mx-auto">
            <v-card-text>
              <div class="caixa-info-lista">
                <h3 class="titulo-lista">
                  Atendimentos não encerrados no primeiro contato e abertos por
                  {{ nomeDoLoginOuGrupoFiltrado }}
                </h3>
              </div>
              <div class="caixa-numero" v-show="!erroConexao && !loading">
                <p>Total:</p>
                <p class="numero-lista">
                  {{ NumeroatendimentosNaoEncerradosPrimeiroContato }}
                </p>
              </div>
              <v-text-field
                v-show="!erroConexao && !loading"
                v-model="pesquisarAtendimentosNaoEncerradosPrimeiroContato"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                class="mt-3 pt-0"
              ></v-text-field>
            </v-card-text>
            <div
              v-if="!erroConexao && loading"
              class="tamanho-lista d-flex justify-center align-center"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div class="mensagem-erro" v-if="erroConexao">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-3"
                    color="red"
                    large
                    v-bind="attrs"
                    v-on="on"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <!-- <span class="ml-3">Erro de conexão</span> -->
                </template>
                <span>Erro de conexão</span>
              </v-tooltip>
            </div>
            <v-data-table
              v-show="!erroConexao && !loading"
              :headers="headersAtendimentosNaoEncerradosPrimeiroContato"
              :items="atendimentosNaoEncerradosPrimeiroContato"
              :search="pesquisarAtendimentosNaoEncerradosPrimeiroContato"
              :loading="loading"
              loading-text="Carregando informações..."
              height="224"
              class="elevation-1"
              sort-by="codigoChamada"
              sort-desc
              dense
              hide-default-footer
              fixed-header
              disable-pagination
            >
              <template v-slot:[`item.codigoChamada`]="{ item }">
                <a
                  target="_blank"
                  :href="`${urlBimerUp}${item.codigoChamada}/historico`"
                >
                  {{ item.codigoChamada }}
                </a>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" class="pa-2">
          <v-card min-height="290" class="mx-auto">
            <v-card-text>
              <div class="caixa-info-lista">
                <h3 class="titulo-lista">
                  Atendimentos abertos por outros usuários e encerrados por
                  {{ nomeDoLoginOuGrupoFiltrado }}
                </h3>
              </div>
              <div class="caixa-numero" v-show="!erroConexao && !loading">
                <p>Total:</p>
                <p class="numero-lista">
                  {{ NumeroAtendimentosAbertosPorTerceirosEncerradosPorMim }}
                </p>
              </div>
              <v-text-field
                v-show="!erroConexao && !loading"
                v-model="
                  pesquisarAtendimentosAbertosPorTerceirosEncerradosPorMim
                "
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                class="mt-3 pt-0"
              ></v-text-field>
            </v-card-text>
            <div
              v-if="loading"
              class="tamanho-lista d-flex justify-center align-center"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div class="mensagem-erro" v-if="erroConexao">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-3"
                    color="red"
                    large
                    v-bind="attrs"
                    v-on="on"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <!-- <span class="ml-3">Erro de conexão</span> -->
                </template>
                <span>Erro de conexão</span>
              </v-tooltip>
            </div>
            <v-data-table
              v-if="!erroConexao && !loading"
              :headers="headersAtendimentosAbertosPorTerceirosEncerradosPorMim"
              :items="atendimentosAbertosPorTerceirosEncerradosPorMim"
              :search="pesquisarAtendimentosAbertosPorTerceirosEncerradosPorMim"
              :loading="loading"
              loading-text="Carregando informações..."
              height="224"
              class="elevation-1"
              sort-by="codigoChamada"
              sort-desc
              dense
              hide-default-footer
              fixed-header
              disable-pagination
            >
              <template v-slot:[`item.codigoChamada`]="{ item }">
                <a
                  target="_blank"
                  :href="`${urlBimerUp}${item.codigoChamada}/historico`"
                >
                  {{ item.codigoChamada }}
                </a>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <ModalLegendas
      v-if="mostrarModalLegendas"
      @fecharModal="fecharModalLegendas"
    />
  </v-container>
</template>

<script>
import mixinMensagen from "@/mixin/mixin-mensagem";
import ModalLegendas from "@/components/modal/ModalLegendas.vue";
import MetadadosAtendimentos from "@/model/dashboard/MetadadosAtendimentos";
import Atendimento from "@/model/dashboard/Atendimento";
import AtendimentoDeTerceiros from "@/model/dashboard/AtendimentoDeTerceiros";
import storage from "@/utils/storage";
import dashboardApi from "@/api/dashboard/dashboard-api";
import grupoApi from "@/api/grupo/grupo-api";
import funcionarioApi from "@/api/funcionario/funcionario-api";
import data from "@/utils/data";
import {
  TIPO_FILTRO,
  TIPO_FILTRO_OPCOES,
  TIPO_PERFIL_USUARIO,
  CORES_GRAFICO,
} from "@/constants/geral-constants";
import Datepicker from "@/components/comum/Datepicker.vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import { reject } from "q";
import Usuario from "@/model/usuario/Usuario";
import templatePDF from "@/templates/dashboard-pdf";
import utilImpressao from "@/utils/impressao";
highchartsMore(Highcharts);

export default {
  components: { ModalLegendas, Datepicker },
  name: "Dashboard",
  mixins: [mixinMensagen],

  data() {
    return {
      pesquisarAtendimentosNaoEncerradosPrimeiroContato: "",
      pesquisarAtendimentosAbertosPorTerceirosEncerradosPorMim: "",
      headersAtendimentosNaoEncerradosPrimeiroContato: [
        {
          text: "Atendimento",
          value: "codigoChamada",
          width: "136px",
        },
        {
          text: "Dias em aberto",
          value: "diasEmAberto",
        },
        {
          text: "Usuário abertura",
          value: "loginUsuario",
        },
      ],
      headersAtendimentosAbertosPorTerceirosEncerradosPorMim: [
        {
          text: "Atendimento",
          value: "codigoChamada",
          width: "136px",
        },
        {
          text: "Usuário abertura",
          value: "loginUsuarioAbertura",
        },
        {
          text: "Usuário encerramento",
          value: "loginUsuarioEncerramento",
        },
      ],
      loading: false,
      apresentarDashboard: false,
      mostrarModalLegendas: false,
      isFiltroAnalista: true,
      isFiltroGrupo: false,
      filtroPersonalizado: false,
      erroConexao: false,
      usuarioLogado: new Usuario(),
      analistas: [],
      grupos: [],
      nomeDoLoginOuGrupoFiltrado: "",
      analistaSelecionado: "",
      loginsPesquisados: [],
      grupoSelecionado: null,
      tipoVisao: "Analista",
      tipoVisaoOpcoes: ["Analista", "Grupo"],
      tipoFiltroItems: TIPO_FILTRO,
      periodoFiltro: TIPO_FILTRO_OPCOES.HOJE,
      tiposPerfilUsuario: TIPO_PERFIL_USUARIO,
      urlBimerUp: process.env.VUE_APP_BIMERUP_URL,
      hoje: new Date().toISOString(),
      dataInicial: new Date(),
      dataFinal: new Date(),
      periodoInicial: new Date().toString(),
      periodoFinal: new Date().toString(),
      periodoMaximo: new Date().toString(),
      atendimentosNaoEncerradosPrimeiroContato: [],
      atendimentosAbertosPorTerceirosEncerradosPorMim: [],
      metadadosAtendimentos: [],
      primeiraRodada : true,
      erroDataInicial : "",
      erroDataFinal : ""
    };
  },

  computed: {
    tamanhoCampoFiltro() {
      return this.periodoFiltro === TIPO_FILTRO_OPCOES.ULTIMOS30DIAS
        ? { "max-width": "185px" }
        : { "max-width": "150px" };
    },

    formatarDataInicial() {
      return data.aplicarMascaraEmDataIso(this.dataInicial);
    },

    formatarDataFinal() {
      return data.aplicarMascaraEmDataIso(this.dataFinal);
    },


    desabilitarBotaoPdf() {
      return this.loading || this.erroConexao || !this.apresentarDashboard;
    },

    totalAbertosNovos() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) => acc + elemento.totalAbertosNovos,
            0
          )
        : 0;
    },

    totalAbertos() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) => acc + elemento.totalAbertos,
            0
          )
        : 0;
    },

    totalResolvidosPrimeiroContato() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) => acc + elemento.totalResolvidosNoPrimeiroContato,
            0
          )
        : 0;
    },

    totalResolvidosDeTerceiros() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) => acc + elemento.totalResolvidosDeTerceiros,
            0
          )
        : 0;
    },

    totalAtendimentosResolvidos() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) => acc + elemento.totalResolvidos,
            0
          )
        : 0;
    },

    totalOutrosResolvidos() {
      return this.metadadosAtendimentos.length != 0
        ? this.metadadosAtendimentos.reduce(
            (acc, elemento) =>
              acc +
              (elemento.totalResolvidos -
                elemento.totalResolvidosNoPrimeiroContato -
                elemento.totalResolvidosDeTerceiros),
            0
          )
        : 0;
    },

    NumeroAtendimentosAbertosPorTerceirosEncerradosPorMim() {
      return !this.loading &&
        this.atendimentosAbertosPorTerceirosEncerradosPorMim.length != 0
        ? this.atendimentosAbertosPorTerceirosEncerradosPorMim.length
        : 0;
    },

    NumeroatendimentosNaoEncerradosPrimeiroContato() {
      return !this.loading &&
        this.atendimentosNaoEncerradosPrimeiroContato.length != 0
        ? this.atendimentosNaoEncerradosPrimeiroContato.length
        : 0;
    },
  },

  async mounted() {
    this.obterUsuarioLogado();
    await this.obterInformacoesDosAnalistasEGrupos();
    this.primeiraRodada=false;
  },

  methods: {
    aguarda(milissegundos) {
      return new Promise(resolve => setTimeout(resolve, milissegundos));
    },

    async validaDatas() {
      await this.aguarda(100);
      this.erroDataInicial = "";
      this.erroDataFinal = "";

      if (!this.periodoInicial) {
          this.erroDataInicial = "Informe uma data válida";
          return false;
      }

      if (!this.periodoFinal) {
          this.erroDataFinal = "Informe uma data válida";
          return false;
      }

      if (this.periodoFinal < this.periodoInicial) {
        this.erroDataFinal = "Data inferior a data inicial";
        return false;
      }

      const milissegundos = new Date(this.periodoFinal).setHours(0,0,0,0) - new Date(this.periodoInicial).setHours(0,0,0,0);
      const segundos = milissegundos / 1000;
      const minutos = segundos / 60;
      const horas = minutos / 60;
      const dias = horas / 24;

      if (dias > 90) {
          this.erroDataInicial = "Máximo de 90 dias";
          this.erroDataFinal = "Máximo de 90 dias";
          return false;
      }
      return true;
    },

    gerarPDFdeRelatorio() {
      let conteudo = templatePDF.gerarPdf(
        this.nomeDoLoginOuGrupoFiltrado,
        this.formatarDataInicial,
        this.formatarDataFinal,
        this.metadadosAtendimentos,
        this.atendimentosNaoEncerradosPrimeiroContato,
        this.atendimentosAbertosPorTerceirosEncerradosPorMim
      );
      utilImpressao.imprimir(conteudo);
    },

    async obterInformacoesDosAnalistasEGrupos() {
      if (this.usuarioLogado.perfil.id != TIPO_PERFIL_USUARIO.ANALISTA) {
        try {
          await this.obterAnalistas();
          await this.obterGrupos();
        } catch (error) {
          this.erroConexao = true;
          this.loading = false;
          this.dispararMensagem(
            (error &&
              error.data &&
              error.data.erros &&
              error.data.erros.join(" ")) ||
              "Não foi possível se comunicar com o servidor!",
            "error",
            3000
          );
        }
      }
    },

    abrirModalLegendas() {
      this.mostrarModalLegendas = true;
    },

    fecharModalLegendas() {
      this.mostrarModalLegendas = false;
    },

    obterUsuarioLogado() {
      this.usuarioLogado = storage.obterUsuarioAtualStorage();
    },

    async obterAnalistas() {
      await funcionarioApi
        .obterFuncionariosPorLoginUsuario(this.usuarioLogado.login)
        .then((response) => {
          this.analistas = response.data.map((a) => a.login);
        })
        .catch((error) => reject(error));
    },

    async obterGrupos() {
      await grupoApi
        .obterTodosGruposDoUsuarioLogado(this.usuarioLogado.login)
        .then((response) => {
          this.grupos = response.data.map((g) => g);
        })
        .catch((error) => reject(error.response));
    },

    exibirOpcoesVisao() {
      if (this.tipoVisao == "Analista") {
        this.isFiltroAnalista = true;
        this.isFiltroGrupo = false;
      } else {
        this.isFiltroAnalista = false;
        this.isFiltroGrupo = true;
      }
    },

    exibirCamposData() {
      if (this.periodoFiltro == TIPO_FILTRO_OPCOES.PERSONALIZADO) {
        this.filtroPersonalizado = true;
      } else {
        this.filtroPersonalizado = false;
      }
    },

    async obterDadosDosGraficos() {
      await dashboardApi
        .obterNumerosTotaisDeAtendimentos(
          this.loginsPesquisados,
          this.dataInicial,
          this.dataFinal
        )
        .then((response) => {
          this.metadadosAtendimentos = response.data.map(
            (x) => new MetadadosAtendimentos(x)
          );
        })
        .catch((error) => reject(error.response));
    },

    definirDatasASeremPesquisadas(filtro, dataInformada) {
      switch (filtro) {
        case TIPO_FILTRO_OPCOES.HOJE:
          this.dataInicial = dataInformada;
          this.dataFinal = dataInformada;
          break;
        case TIPO_FILTRO_OPCOES.ESTASEMANA:

          this.dataInicial = data.primeiroDiaSemanaAtual(dataInformada);
          this.dataFinal = data.ultimoDiaSemana(dataInformada);

          break;
        case TIPO_FILTRO_OPCOES.ESTEMES:
          this.dataInicial = data.primeiroDiaMesAtual(dataInformada);
          this.dataFinal = data.ultimoDiaMes(dataInformada);
          break;
        case TIPO_FILTRO_OPCOES.ULTIMOS30DIAS:
          this.dataInicial = data.ultimosTrintaDias(dataInformada);
          this.dataFinal = dataInformada;
          break;
        case TIPO_FILTRO_OPCOES.DIAANTERIOR:
          this.dataInicial = data.diaAnterior(dataInformada);
          this.dataFinal = data.diaAnterior(dataInformada);
          break;
        case TIPO_FILTRO_OPCOES.PERSONALIZADO:
          this.filtroPersonalizado = true;
          this.dataInicial = this.periodoInicial;
          this.dataFinal = this.periodoFinal;
          break;
        default:
          this.dataInicial = dataInformada;
          this.dataFinal = dataInformada;
      }

      const dataInicialFormatada = data.formatarDataAnoMesDia(this.dataInicial);
      const dataFinalFormatada = data.formatarDataAnoMesDia(this.dataFinal);

      return [dataInicialFormatada, dataFinalFormatada];
    },

    async filtrarInformacoesDashboard() {

      if(!await this.validaDatas()) {
        return;
      }

      this.loading = true;
      this.erroConexao = false;
      this.filtroPersonalizado = false;
      this.apresentarDashboard = true;
      this.definirAnalistasASeremPesquisados();
      var datas = this.definirDatasASeremPesquisadas(
        this.periodoFiltro,
        this.hoje
      );

      this.dataInicial = datas[0];
      this.dataFinal = datas[1];

      try {
        await this.obterDadosDosGraficos();
        this.montarGraficoChamadosAbertos();
        this.montarGraficoChamadosResolvidos();

        await this.obterDadosListaAtendimentosNaoEncerradosPrimeiroContato();
        await this.obterDadosListaAtendimentosAbertosPorTerceirosEncerradosPelosLoginsPesquisado();

        this.verificarSeTemInformacoesParaMostrarNoDashboard();
      } catch (error) {
        this.erroConexao = true;
        this.dispararMensagem(
          (error &&
            error.data &&
            error.data.erros &&
            error.data.erros.join(" ")) ||
            "Não foi possível se comunicar com o servidor!",
          "error",
          15000
        );
      }
      this.loading = false;
    },

    async obterDadosListaAtendimentosNaoEncerradosPrimeiroContato() {
      await dashboardApi
        .obterTodosAtendimentosNaoEncerradosPrimeiroContato(
          this.loginsPesquisados,
          this.dataInicial,
          this.dataFinal
        )
        .then((response) => {
          this.atendimentosNaoEncerradosPrimeiroContato = response.data.map(
            (x) => new Atendimento(x)
          );
        })
        .catch((error) => reject(error.response));
    },

    async obterDadosListaAtendimentosAbertosPorTerceirosEncerradosPelosLoginsPesquisado() {
      await dashboardApi
        .obterTodosAtendimentosAbertosPorTerceirosEncerradosPorMim(
          this.loginsPesquisados,
          this.dataInicial,
          this.dataFinal
        )
        .then((response) => {
          this.atendimentosAbertosPorTerceirosEncerradosPorMim =
            response.data.map((x) => new AtendimentoDeTerceiros(x));
        })
        .catch((error) => reject(error.response));
    },

    definirAnalistasASeremPesquisados() {
      if (this.usuarioLogado.perfil.id === TIPO_PERFIL_USUARIO.ANALISTA) {
        this.analistaSelecionado = this.usuarioLogado.login;
        this.loginsPesquisados = [this.usuarioLogado.login];
        this.nomeDoLoginOuGrupoFiltrado = this.usuarioLogado.login;
      } else if (this.isFiltroAnalista) {
          if (!this.analistaSelecionado) {
            this.analistaSelecionado = "";
            this.nomeDoLoginOuGrupoFiltrado = "";
            if(this.analistas.indexOf(this.usuarioLogado.login)){
              this.analistaSelecionado = (this.usuarioLogado.login);
            }
        } else {
          this.nomeDoLoginOuGrupoFiltrado = this.analistaSelecionado;
        }
        this.loginsPesquisados = [this.analistaSelecionado];
      } else {
        this.loginsPesquisados = this.grupoSelecionado.funcionariosGrupo.map(
          (x) => x.login
        );
        this.nomeDoLoginOuGrupoFiltrado = this.grupoSelecionado.descricao;
      }
    },

    verificarSeTemInformacoesParaMostrarNoDashboard() {
      if (this.totalAtendimentosResolvidos == 0 && this.totalAbertos == 0) {
        this.apresentarDashboard = false;
      } else {
        this.apresentarDashboard = true;
      }
    },

    montarGraficoChamadosAbertos() {
      const isDark = this.$vuetify.theme.dark;
      const bgColor = isDark ? '#1e1e1e' : '#ffffff';
      const textColor = isDark ? '#ffffff' : '#333333';
      Highcharts.chart({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          renderTo: "grafico-chamados-abertos",
          backgroundColor: bgColor,
        },
        title: {
          text: null,
        },
        legend: { itemStyle: { color: textColor } },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}</b>",
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "{point.y}",
              distance: -40,
            },
            showInLegend: true,
          },
        },

        accessibility: {
          point: {
            valueSuffix: "Un",
          },
        },

        series: [
          {
            name: "Atendimentos abertos",
            colorByPoint: true,
            data: [
              {
                name: "Novos",
                y: this.totalAbertosNovos,
                color: CORES_GRAFICO.AZUL,
              },
              {
                name: "Outros",
                y: this.totalOutrosAtendimentosAbertos,
                color: CORES_GRAFICO.AZUL_MAIS_CLARO,
              },
            ],
          },
        ],
      });
    },

    montarGraficoChamadosResolvidos() {
      const isDark = this.$vuetify.theme.dark;
      const bgColor = isDark ? '#1e1e1e' : '#ffffff';
      const textColor = isDark ? '#ffffff' : '#333333';
      Highcharts.chart({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          renderTo: "grafico-chamados-resolvidos",
          backgroundColor: bgColor,
        },
        title: {
          text: null,
        },
        legend: { itemStyle: { color: textColor } },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "{point.y}",
              distance: -20,
            },
            showInLegend: true,
          },
        },

        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },

        series: [{
          name: "Atendimentos resolvidos",
          colorByPoint: true,
          innerSize: "50%",
          data: [
            ...(this.totalResolvidosPrimeiroContato !== 0
              ? [
                {
                  name: "Primeiro contato",
                  y: this.totalResolvidosPrimeiroContato,
                  color: CORES_GRAFICO.AZUL_CLARO,
                },
              ]
              : []),
            ...(this.totalResolvidosDeTerceiros !== 0
              ? [
                {
                  name: "Abertos por terceiros",
                  y: this.totalResolvidosDeTerceiros,
                  color: CORES_GRAFICO.AMARELO,
                },
              ]
              : []),
          ],
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  color: $cor_primaria;
}

.titulo-grafico {
  padding-top: 10px;
  font-weight: 400;
  text-align: center;
  color: inherit;
}

.titulo-lista {
  padding-top: 7px;
  font-weight: 400;
  color: inherit;
}

.numero-lista {
  color: $cor_primaria;
  font-size: 16px;
  font-weight: 600;
  background-color: rgba(77, 157, 224, 0.15);

  width: 32px;
  height: 32px;
  border-radius: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
}

a {
  color: $cor_primaria;
}

.tamanho-grafico {
  height: 300px;
}

.tamanho-lista {
  height: 200px;
}

.fonte-legenda {
  font-size: 12px;
  font-style: italic;
}

.fundo-numero {
  width: 190px;
  height: 190px;
  border: 18px solid #00000060;
  border-radius: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

.numero-card {
  text-align: center;
  font-size: 60px;
  color: #00000087;
}

.mensagem-erro {
  display: flex;
  height: 200px;
  justify-content: center;
  align-items: center;
  color: red;
}

.descricao-card {
  text-align: center;
  font-size: 20px;
  color: #00000087;
}

.texto-label {
  font-size: 12px;
}

.sem-informacoes-periodo {
  width: 100%;
  text-align: center;
  border: 1px solid rgba(0,0,0,0.2);
  padding: 30px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 600;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 41px !important;
}

.btn-info {
  width: 20px;
  height: 20px;
}

.caixa-info-lista {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;

  /* min-height: 51px; */
}
.caixa-numero {
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
